export default "__VITE_ASSET__BrJb8Q6l__"